import "owl.carousel";
import lightbox from "lightbox2/dist/js/lightbox";
const $ = window.jQuery;
const $window = window.$window || $(window);

const Navigation = {
  init() {
    $(`.primary-menu > li`).has(`ul`).find('> a').click((event) => {
        event.preventDefault();
    });
  },
};

export default Navigation;
